import ProfessionalismIcon from "../../../../assets/icons/professionalism.png";
import StabilityIcon from "../../../../assets/icons/stability.png";
import LatestMachineIcon from "../../../../assets/icons/latestmachine.png";
export const iconData = [
  {
    icon: ProfessionalismIcon,
    title: "Professionalism",
    description:
      "Experience the embodiment of professionalism in every brick laid and road paved with us",
  },
  {
    icon: StabilityIcon,
    title: "Stability",
    description:
      "Building a Sustainable Future: 3handsons is Your Trusted Partner in Crafting Resilient Structures and Roads",
  },
  {
    icon: LatestMachineIcon,
    title: "Machinery",
    description:
      "Empowered by Cutting-edge Machinery for Precision in Building and Road Construction",
  },
];
